import React, { useEffect, useMemo } from 'react';
import { AppBarCMS } from '../../../../../basic';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { EduCourseDatesForm } from './EduCourseDatesForm.jsx';
import {
  useGetEduCourseDateQuery,
  useGetEduCourseDatesQuery,
  useSaveEduCourseDateMutation,
} from '../../../../../../redux/services/eduCourseDates';
import { isUndefined } from 'lodash';
import { Spinner } from '../../../../../common';
import dayjs from 'dayjs';
import { DATETIME_FORMAT_TIME } from '../../../../../../utils/helpers/CommonHelper';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';

export const EduCourseDatesEdit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { courseId, dateId } = useParams();
  const isCreate = isUndefined(dateId);

  const { saveSuccess } = useToastMessages();

  const [saveCourseDate, { isSuccess, isError, error }] =
    useSaveEduCourseDateMutation();

  // Load a single course date detail for edit (skip on create)
  const { data: courseDate, isLoading } = useGetEduCourseDateQuery(dateId, {
    skip: isCreate,
  });

  // Prepare refetch for list of dates of this course after save
  const { refetch } = useGetEduCourseDatesQuery(courseId, { skip: !courseId });

  useEffect(() => {
    const title = isCreate
      ? t('Pridanie termínu kurzu')
      : t('Editácia termínu kurzu');
    document.title = 'FRI.edu - ' + title;
  }, [isCreate, t]);

  useEffect(() => {
    if (isSuccess) {
      saveSuccess();
      refetch();
      navigate(-1);
    }
  }, [isSuccess]);

  const { apiErrorMessage } = useToastMessages();
  useEffect(() => {
    if (isError && error) {
      // Show toast with aggregated validation or generic error
      apiErrorMessage(error);
    }
  }, [isError, error]);

  const handleSubmit = (data) => {
    if (!courseId) return;
    saveCourseDate({ id: dateId, data, courseId });
  };

  const initials = useMemo(() => {
    if (!courseDate) return {};

    const [timeFrom, timeTo] = (courseDate.time || '00:00 - 00:00').split(
      ' - ',
    );

    return {
      date_registration_closed: dayjs(courseDate.date_registration_closed),
      dates: [dayjs(courseDate.date_from), dayjs(courseDate.date_to)],
      capacity: courseDate.capacity,
      place: courseDate.place,
      time: [
        dayjs(timeFrom, DATETIME_FORMAT_TIME),
        dayjs(timeTo, DATETIME_FORMAT_TIME),
      ],
    };
  }, [courseDate]);

  return !isCreate && isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={
          isCreate ? t('Pridanie termínu kurzu') : t('Editácia termínu kurzu')
        }
        backUrl={-1}
        backUrlTooltip={t('Späť na zoznam kurzov')}
        permissionsBasic="fri-edu-courses"
      />
      <div style={{ margin: '10px' }}>
        <EduCourseDatesForm
          onSubmit={handleSubmit}
          initials={initials}
          serverErrors={isError ? error?.data?.errors || {} : {}}
        />
      </div>
    </>
  );
};

export default EduCourseDatesEdit;
